const defaultErrorMessage = 'Something went wrong. Please, try again later.';

const buildErrorMessage = msg => msg || defaultErrorMessage;

export default buildErrorMessage;
